export default "__VITE_ASSET__ODKsz5vA__"